import { ThemeProvider, createTheme } from "@material-ui/core/styles";

export const CustomTheme = ({ children }) => {
  const theme = createTheme({
    palette: {
      primary: { main: "#4187B6" },
    },
    typography: {
      fontFamily: "'Roboto', serif",
      body2: { letterSpacing: 0 },
    },
    overrides: {
      MuiPaper: {
        root: { "& a": { textDecoration: "none", color: "inherit" } },
      },
      MuiTypography: {
        h1: { fontSize: 35, lineHeight: 1.31, color: "#353535" },
        h2: { fontSize: 26, lineHeight: 1.31, color: "#353535" },
        h3: {
          fontWeight: 800,
          fontSize: "1.5rem",
          lineHeight: 1.31,
          color: "#353535",
        },
        h4: { lineHeight: 1.31, color: "#353535" },
        h5: { lineHeight: 1.31, color: "#353535" },
        h6: { lineHeight: 1.31, color: "#353535" },
        body1: { fontWeight: 400, fontSize: "1rem", letterSpacing: 0 },
      },
      MuiButton: {
        root: {
          boxShadow: "none",
          backgroundColor: "#FFFFFF",
          color: "#a6a6a6",
          fontSize: 14,
          lineHeight: 1.36,
          textAlign: "center",
          textTransform: "capitalize",
          border: "none",
          borderRadius: 3,
          fontWeight: 500,
          padding: "8px 16px",
          "&:hover": { backgroundColor: "#e4eaec", color: "#a6a6a6" },
        },
        colorInherit: { backgroundColor: "inherit" },
        contained: {
          boxShadow: "none",
          backgroundColor: "#FFFFFF",
          border: "solid 1px #e4eaec",
          color: "#a6a6a6",
          "&:hover": {
            backgroundColor: "#e4eaec",
            boxShadow: "none",
            color: "#a6a6a6",
          },
        },
        containedPrimary: {
          backgroundColor: "#4187B6",
          border: "none",
          "&:hover": {
            backgroundColor: "#0d6ca1",
            boxShadow: "none",
            color: "#FFFFFF",
          },
          color: "#FFFFFF",
        },
        containedSecondary: {
          backgroundColor: "#d62733",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#a41d26",
            boxShadow: "none",
            color: "#FFFFFF",
          },
        },
        textPrimary: {
          backgroundColor: "#4187B6",
          color: "#FFFFFF",
          "&:hover": { backgroundColor: "#0d6ca1", color: "#FFFFFF" },
        },
        outlinedSecondary: {
          backgroundColor: "#FFFFFF",
          color: "#a6a6a6",
          borderColor: "#a6a6a6",
          "&:hover": {
            backgroundColor: "#e4eaec",
            color: "#a6a6a6",
            borderColor: "#a6a6a6",
          },
        },
      },
      MuiSnackbar: {
        root: {
          right: "8px !important",
          left: "initial !important",
          transform: "translateX(0) !important",
        },
      },
      MuiFormControl: {
        root: { width: "100%" },
        marginNormal: { marginTop: 24, marginBottom: 24 },
      },
      MuiInputBase: {
        input: {
          "&.Mui-disabled": {
            color: "#a6a6a6 !important",
            backgroundColor: "#f3f7f9",
          },
        },
        root: {
          "&.Mui-disabled": {
            color: "#a6a6a6 !important",
            backgroundColor: "#f3f7f9",
          },
        },
      },
      MuiInputLabel: {
        outlined: { transform: "translate(0, -24px) !important" },
      },
      MuiOutlinedInput: {
        input: { padding: "7px 14px", minHeight: 34 },
        root: {
          borderRadius: 2,
          color: "#a6a6a6",
          "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e4eaec !important",
          },
          "&:hover": {
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#4187B6" },
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: 1,
            borderColor: "#4187B6",
          },
          "& fieldset > legend > span": { display: "none" },
        },
        notchedOutline: { borderColor: "#e4eaec" },
      },
      MuiTab: { wrapper: { alignItems: "flex-start" } },
      MuiTableContainer: {
        root: { "&.FiltersContainer": { marginBottom: "24px" } },
      },
      MuiList: {
        root: {
          "& a.active": {
            "& .MuiButtonBase-root": {
              textDecoration: "none",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          },
        },
      },
      MuiAppBar: {
        colorPrimary: { backgroundColor: "#4187B6", color: "#FFFFFF" },
        root: {
          "& .MuiButton-root": {
            backgroundColor: "#4187B6",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#0d6ca1", color: "#FFFFFF" },
          },
        },
      },
      MuiCollapse: {
        root: {
          width: "100%",
        },
      },
      MuiCssBaseline: {
        "@global": {
          ".moduleTitle": {
            color: "#0F172A",
            fontFamily: "Inter",
            padding: "0px",
            backgroundColor: "white",
            fontWeight: "600",
            fontSize: "1.875rem",
          },
          ".MuiMenuItem-root, .MuiOutlinedInput-input": {
            fontFamily: "Inter",
            color: "#000000",
            fontWeight: "400",
            fontSize: "1rem",
          },
          ".MuiSelect-icon": {
            color: "black",
          },
          "iframe#resource-iframe": {
            border: "none",
          },
          ".makeStyles-container-220": {
            fontSize: "1rem",
            fontWeight: "400",
            fontFamily: "Lato",
          },
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
